import { Fragment, useContext, useEffect, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from "react-hook-form";

import { Dialog, Transition } from "@headlessui/react";
import PropTypes from "prop-types";

import { ToastContext } from "common/contexts";
import getGAUserID from "common/fetch/getGAUserID";
import sendData from "common/fetch/post";

import ButtonNew from "components/atoms/ButtonNew/index";
import { BiLoaderAlt } from "components/atoms/Icon/bi/BiLoaderAlt";
import { FaTimes } from "components/atoms/Icon/fa/FaTimes";
import Img from "components/atoms/Img";
import { InputEmail, InputText } from "components/atoms/Input/index";
import Title from "components/atoms/Title";
import Toast from "components/atoms/Toast";

import styles from "./Index.module.scss";

/** ========== */

const FormDowload = ({ onHide }) => {
  const {
    register,
    handleSubmit,
    reset,
    clearErrors,
    formState: { isSubmitting, errors },
  } = useForm();

  const { openAlert, setOpenAlert } = useContext(ToastContext);
  const recaptchaRef = useRef();

  useEffect(() => {
    const getHash = window.location.hash || "";

    if (getHash.length > 0) {
      document.getElementById(getHash.replace("#", ""))?.click();
    }
  }, []);

  const handlingSuccess = () => {
    reset();
    clearErrors();
  };
  const onSubmitEbook = async (data) => {
    const token = await recaptchaRef.current.executeAsync();

    if (token) {
      const GAUserID = getGAUserID();
      const dataSend = { ...data };

      dataSend.client_id = GAUserID ? GAUserID : "";
      dataSend.website_id = process.env.NEXT_PUBLIC_WEBSITE_ID;
      dataSend.contact_from_id = 39;

      document.getElementById("popup-content-panel").style.display = "none";
      // Axios
      //   .post(
      //     `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/whitepaper`,
      //     Data,
      //     {
      //       Headers: {
      //         "captcha-response": token,
      //       },
      //     }
      // )
      sendData({
        api: `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/whitepaper`,
        data: dataSend,
        token,
      })
        .then((res) => {
          if (res.state) {
            openAlert(5000, "custom", {
              element: (
                <>
                  {/* <ProgressBar timer={timer} color={`bg-bbc-green-500`} /> */}
                  <div className="">
                    <Img
                      src="/assets/icons/checked.png"
                      width={90}
                      height={92}
                      alt="icon success"
                      className="mb-6"
                    />
                  </div>
                  <p className="mb-6 text-2xl font-semibold text-bbc-brand-800">
                    You&apos;re all set!
                  </p>
                  <p className="text-sm text-bbc-gray">
                    Your whitepaper will be sent to your inbox shortly. Please
                    check your email to view your download.
                  </p>
                  <ButtonNew
                    onClick={() => {
                      setOpenAlert(false);
                    }}
                    className="relative mt-4 inline-flex  items-center justify-center rounded-full bg-bbc-brand-500 p-2 text-base text-white hover:bg-bbc-secondary-100 "
                    style={{ width: "160px" }}
                  >
                    OK
                  </ButtonNew>
                </>
              ),
            });
            setTimeout(() => {
              onHide();
            }, 5000);
            handlingSuccess();
          } else {
            openAlert(5000, "error");
            setTimeout(() => {
              onHide();
            }, 5000);
            console.eror("error");
          }
        })
        .catch((e) => {
          openAlert(5000, "error");
          setTimeout(() => {
            onHide();
          }, 5000);
          console.log(e, "error");
        });
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmitEbook)}>
        <div className="mb-3">
          <InputText
            className="w-full rounded-full border-0 px-3 py-2 placeholder:text-[#8E8B8B] focus:ring-0"
            disabled={isSubmitting}
            placeholder="First name"
            register={register}
            errors={errors}
            name="first_name"
          />
        </div>
        <div className="mb-3">
          <InputText
            className="w-full rounded-full border-0 px-3 py-2 placeholder:text-[#8E8B8B] focus:ring-0"
            disabled={isSubmitting}
            placeholder="Last name"
            register={register}
            errors={errors}
            name="last_name"
          />
        </div>
        <div className="mb-3">
          <InputEmail
            className="w-full rounded-full border-0 px-3 py-2 placeholder:text-[#8E8B8B] focus:ring-0"
            disabled={isSubmitting}
            placeholder="Email"
            register={register}
            errors={errors}
            requiredText="This field is required"
          />
        </div>
        <div className="invisible h-0 w-0">
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={process.env.NEXT_PUBLIC_G_RECAPTCHA_V3_SITE_KEY}
            badge="inline"
            size="invisible"
          />
        </div>
        <div className="mb-4">
          <div className="relative flex items-center justify-center">
            <input
              id="read-policy"
              type="checkbox"
              {...register("read-policy", {
                required: {
                  value: true,
                  message: "Please accept Privacy Policy",
                },
              })}
              className="bbc-checkbox mr-2 cursor-pointer rounded-full border-bbc-silver bg-transparent focus:shadow-none focus:outline-none focus:ring-0"
            />
            <label
              htmlFor="read-policy"
              className={"cursor-pointer font-normal text-bbc-white"}
              dangerouslySetInnerHTML={{
                __html:
                  "I accept the <a href='/offshore/privacy-policy' class='underline' target='_blank' rel='nofollow noreferrer'>Privacy Policy</a>",
              }}
            ></label>
          </div>
          {/* {errors["read-policy"] && (
                            <span className="inline-block pt-2 text-sm text-red-500">
                              {errors["read-policy"]?.message}
                            </span>
                          )} */}
        </div>
        <div className="mt-6 text-center lg:mt-0">
          <ButtonNew
            disabled={isSubmitting}
            variant="primary"
            type="submit"
            className="w-full rounded-full border border-bbc-white bg-transparent py-2 font-semibold text-bbc-white duration-200 ease-in-out hover:bg-bbc-white hover:text-bbc-primary"
          >
            {isSubmitting && (
              <BiLoaderAlt
                className="mr-1 inline-block animate-spin"
                size={20}
              />
            )}
            Download Now
          </ButtonNew>
        </div>
      </form>
    </>
  );
};

const Component = ({ show, onHide }) => {
  const closeModal = () => {
    onHide();
  };

  return (
    <>
      <Toast>
        <Transition show={show} as={"div"}>
          <Dialog
            as="div"
            unmount={false}
            className="fixed inset-0 overflow-y-auto"
            style={{ zIndex: 99 }}
            onClose={closeModal}
          >
            <div aria-hidden="true" className="min-h-screen px-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-slate-900 opacity-70" />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="inline-block h-screen align-middle"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <div
                  id="popup-content-panel"
                  className={`${styles.WhitepaperModal} relative inline-flex w-full transform flex-col justify-center overflow-hidden px-4 pt-6 pb-6 text-left align-middle transition-all lg:px-10 lg:pb-10`}
                >
                  <Img
                    src="/assets/images/offshore/guide-and-tool/whitepaper/bg_form-offshore-whitepaper.png"
                    alt="bg_form-offshore-whitepaper"
                    className="absolute left-0 top-0 z-0 h-full object-cover"
                    width={1110}
                    height={405}
                  />
                  <div className="absolute top-4 right-4 z-20 mb-4 text-right leading-none lg:mb-8">
                    <button
                      type="button"
                      onClick={closeModal}
                      className="rounded-full border border-bbc-white p-[1px]"
                    >
                      <FaTimes className="text-bbc-white" size={16} />
                    </button>
                  </div>
                  <div className="row relative z-10 items-center">
                    <div className="col-12 lg:col-4">
                      <Title
                        as="h3"
                        text="Want Happier Clients And Healthier Profits?"
                        className={`${styles.WhitepaperTitle} mb-4 text-center font-semibold text-bbc-white lg:text-left`}
                      />
                      <p className="text-center text-bbc-white lg:text-left">
                        Explore how firms are simplifying entity formation and
                        enhancing client value.
                      </p>
                    </div>
                    <div className="col-12 flex justify-center py-6 lg:col-4 lg:py-0">
                      <Img
                        src="/assets/images/offshore/guide-and-tool/whitepaper/modalwhitepaper-offshore-guide.png"
                        alt="whitepaper-guide"
                        width={224}
                        height={315}
                      />
                    </div>
                    <div className="col-12 lg:col-4">
                      <FormDowload onHide={onHide} />
                    </div>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition>
      </Toast>
    </>
  );
};

Component.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  nameProps: PropTypes.object,
  emailProps: PropTypes.object,
  messageProps: PropTypes.object,
  triggerName: PropTypes.string,
  contactFromId: PropTypes.number,
  apiLink: PropTypes.string,
  haveCheckBox: PropTypes.any,
  checkedId: PropTypes.any,
  unCheckId: PropTypes.any,
  checkboxText: PropTypes.string,
  checkboxTextClassName: PropTypes.string,
};

Component.defaultProps = {
  title: "",
  description: "",
  nameProps: {},
  emailProps: {},
  messageProps: {},
  checkboxTextClassName: "",
};

export default Component;

/** ========== */
